import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n  input[type=\'number\'] {\n    width: 50px;\n    border: none;\n    background: ', ';\n    border-radius: 8px;\n    text-align: center;\n    padding: 6px;\n    margin: 0 8px;\n  }\n'], ['\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n  input[type=\'number\'] {\n    width: 50px;\n    border: none;\n    background: ', ';\n    border-radius: 8px;\n    text-align: center;\n    padding: 6px;\n    margin: 0 8px;\n  }\n']);

import React from 'react';
import styled from 'styled-components';

import { styles, translations } from 'gipsy-misc';

var Container = styled.div(_templateObject, styles.colors.borderColor);

var Every = function Every(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      label = _ref.label;

  var rounded = Math.round(value);
  if (rounded !== value) {
    throw new Error("'value' should be an integer");
  }

  return React.createElement(
    Container,
    null,
    React.createElement(
      'label',
      { htmlFor: 'daily-every' },
      translations.taskPanel.recurrency.every,
      React.createElement('input', { value: value, onChange: function onChange(e) {
          return _onChange(Math.round(e.target.value));
        }, id: 'daily-every', type: 'number' })
    ),
    label
  );
};

export default Every;
//# sourceMappingURL=EveryInput.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/When/RecurrencyDetails/components/EveryInput.js
// module id = 309
// module chunks = 0